import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';


export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-gray-900 border-t border-white/10 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="https://storage.readdy-site.link/project_files/ea087323-c332-4d1a-a768-642201e38806/8e03886a-a466-4209-8fc0-30625673693c_ONETV.png?v=410354e2b00bf17cf48639a5651635ec" alt="Onetvservices Logo" className="h-16 w-auto object-contain" width={250} height={100} />

            </div>
            <p className="text-muted-foreground text-sm">Streaming TV Premium International - Films, Séries &amp; Chaînes TV en 4K</p>
          </div>
          <div>
            <h3 className="font-heading text-lg mb-4 text-white">{t('footer.services')}</h3>
            <ul className="space-y-2 text-muted-foreground text-sm">
              <li>{t('footer.s1')}</li><li>{t('footer.s2')}</li><li>{t('footer.s3')}</li><li>{t('footer.s4')}</li>
            </ul>
          </div>
          <div>
            <h3 className="font-heading text-lg mb-4 text-white">{t('footer.contact')}</h3>
            <ul className="space-y-2 text-muted-foreground text-sm">
              <li>📞 +1 (208) 974 6525</li><li>📧 onetvservices@gmail.com</li><li>🕒 Support 7j/7 10h-00h</li>
            </ul>
          </div>
          <div>
            <h3 className="font-heading text-lg mb-4 text-white">{t('footer.coverage')}</h3>
            <ul className="space-y-2 text-muted-foreground text-sm">
              <li>{t('footer.cov1')}</li><li>{t('footer.cov2')}</li><li>{t('footer.cov3')}</li><li>{t('footer.cov4')}</li>
            </ul>
          </div>
          <div>
            <h3 className="font-heading text-lg mb-4 text-white">{t('footer.legal')}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors cursor-pointer">
                  {t('footer.l1')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors cursor-pointer">
                  {t('footer.l2')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors cursor-pointer">
                  {t('footer.l3')}
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-muted-foreground hover:text-primary transition-colors cursor-pointer">
                  {t('footer.l4')}
                </Link>
              </li>
              <li><a href="mailto:onetvservices@gmail.com" className="text-muted-foreground hover:text-primary transition-colors">{t('footer.l5')}</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 text-center text-muted-foreground text-sm">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
}
